import { Component, OnInit, Output, Input } from '@angular/core';
import { AllLinksComponent } from 'src/app/core/all-links/all-links.component';
import { LearnerService } from 'src/app/core/services/learner.service';
import { PermissionService } from 'src/app/core/services/permission-service.service';
import { ThemeService } from '../christmas-decoration/services/theme.service';
import { EventEmitter } from '@angular/core';
import { error } from 'console';
import { filter, take } from 'rxjs/operators';
@Component({
  selector: 'app-header-global',
  templateUrl: './header-global.component.html',
  styleUrls: ['./header-global.component.css']
})

export class HeaderGlobalComponent implements OnInit {
  AllLinksComponent: any;
  name: string;
  dates: any;
  fullName: string = "";
  jobTitle: string = " ";
  initials: string = "";
  showText: boolean;
  employeepermissions: any;
  showClaim: boolean;
  employeedata: any;
  imageSrc: string = '';

  // Theme-related properties
  @Input() themeData: any = null;

  constructor(
    private learnerService: LearnerService,
    private permissionService: PermissionService,
    public allLink: AllLinksComponent,
    private themeService: ThemeService

  ) { }

  // Check if theme background is available
  get hasThemeBackground(): boolean {
    return !!this.themeData?.header_bg || !!this.themeData?.header_username;
  }

  // Get dynamic header styles
  getHeaderStyle(): any {
    const styles: any = {};
    
    if (this.themeData?.header_bg) {
      styles['background-image'] = `url("${this.themeData.header_bg}")`;
      styles['background-size'] = 'cover';
      styles['background-position'] = 'center';
      styles['background-repeat'] = 'no-repeat';
    } else if (this.themeData?.header_username) {
      styles['background-image'] = `url("${this.themeData.header_username}")`;
      styles['background-size'] = 'cover';
      styles['background-position'] = 'center';  
      styles['background-repeat'] = 'no-repeat';
    }
    
    return styles;
  }

  ngOnInit(): void {
    this.name = localStorage.getItem('name');
    this.permissionService.getEmployeePermissions()
      .pipe(
        filter(data => !!data),
        take(1)
      )
      .subscribe(data => {
        let res = data;

        //console.log("permission response is ", res);
        const perms = res
        if (!perms) {
          console.log('Employee data not yet loaded');
          return;
        }
        localStorage.setItem('self', perms['self']);
        localStorage.setItem('manager', perms['manager']);
        localStorage.setItem('department_head', perms['department_head']);
        localStorage.setItem('business_head', perms['business_head']);
        localStorage.setItem('company', perms['company']);
        localStorage.setItem('tab', 'self');
      }, (error: any) => {
        console.log(error, error.error, error.message)
      });



    this.permissionService.getEmployeeData()
      .pipe(
        filter(data => !!data),
        take(1)
      )
      .subscribe(data => {
        let empData = data;
        // console.log("empdata", empData);

        if (!empData) {
          console.log('Employee data not yet loaded');
          return;
        }

        this.dates = empData;
        this.fullName = this.dates.name;
        this.jobTitle = this.dates.job_title;
        const names = this.fullName.split(" ");
        if (this.dates.image == "" || this.dates.image == null) {
          this.initials = names[0].charAt(0) + names[names.length - 1].charAt(0);
          this.showText = true;
        }
        else {
          this.showText = false;
          this.imageSrc = `data:image/png;base64,${this.dates.image}`;
        }

      }, (error: any) => {
        console.log(error, error.error, error.message)
      });

    // Load theme data for dynamic header styling
    this.loadThemeData();
  }

  // Load theme data from the theme service
  loadThemeData(): void {
    this.themeService.getThemeData().subscribe({
      next: (data: any) => {
        console.log('Theme data loaded in header:', data);
        this.themeData = data;
      },
      error: (error) => {
        console.error('Error loading theme data in header:', error);
        this.themeData = null;
      }
    });
  }

}